{
	"white": "#fff",
	"black": "#000000",
	"blue.1": "#E6F4FF",
	"blue.2": "#BAE0FF",
	"blue.3": "#72b0ea",
	"blue.4": "#4c9ae2",
	"blue.5": "#2684da",
	"blue.6": "#006ed2",
	"blue.7": "#005db5",
	"blue.8": "#004d96",
	"blue.9": "#002C8C",
	"blue.10": "#001d39",
	"purple.1": "#EFEDF7",
	"purple.2": "#C8C1FA",
	"purple.3": "#ACA1F7",
	"purple.4": "#9082F4",
	"purple.5": "#7563F2",
	"purple.6": "#5944EF",
	"purple.7": "#4A39C7",
	"purple.8": "#3B2D9F",
	"purple.9": "#2D2278",
	"purple.10": "#1E1750",
	"cyan.1": "#f5fefb",
	"cyan.2": "#DEFAE9",
	"cyan.3": "#B9EDCF",
	"cyan.4": "#6ec391",
	"cyan.5": "#49b476",
	"cyan.6": "#25a55a",
	"cyan.7": "#1f8a4b",
	"cyan.8": "#196e3c",
	"cyan.9": "#13532d",
	"cyan.10": "#0c371e",
	"green.1": "#f5f7ed",
	"green.2": "#e2e8cf",
	"green.3": "#d1dbb1",
	"green.4": "#c0ce93",
	"green.5": "#afc175",
	"green.6": "#9eb457",
	"green.7": "#839248",
	"green.8": "#667238",
	"green.9": "#495228",
	"green.10": "#2c3218",
	"magenta.1": "#f9ecf6",
	"magenta.2": "#efd3eb",
	"magenta.3": "#e7b9df",
	"magenta.4": "#df9fd3",
	"magenta.5": "#cf6bbb",
	"magenta.6": "#c751af",
	"magenta.7": "#a94793",
	"magenta.8": "#6d2d5f",
	"magenta.9": "#4f2045",
	"magenta.10": "#520339",
	"red.1": "#faebeb",
	"red.2": "#f1cbca",
	"red.3": "#e6acab",
	"red.4": "#db8d8c",
	"red.5": "#c54f4e",
	"red.6": "#ba302f",
	"red.7": "#982925",
	"red.8": "#77201d",
	"red.9": "#561715",
	"red.10": "#350e0d",
	"orange.1": "#FFF7E6",
	"orange.2": "#FFE7BA",
	"orange.3": "#ffd591",
	"orange.4": "#ffc069",
	"orange.5": "#ffa940",
	"orange.6": "#fa8c16",
	"orange.7": "#d46b08",
	"orange.8": "#ad4e00",
	"orange.9": "#873800",
	"orange.10": "#612500",
	"yellow.1": "#fffdec",
	"yellow.2": "#fff7b3",
	"yellow.3": "#fff48c",
	"yellow.4": "#ffec40",
	"yellow.5": "#e6d43a",
	"yellow.6": "#b3a52d",
	"yellow.7": "#998e26",
	"yellow.8": "#807620",
	"yellow.9": "#665e1a",
	"yellow.10": "#4c4713",
	"volcano.1": "#fff2e8",
	"volcano.2": "#ffd8bf",
	"volcano.3": "#ffbb96",
	"volcano.4": "#ff9c6e",
	"volcano.5": "#ff7a45",
	"volcano.6": "#fa541c",
	"volcano.7": "#d4380d",
	"volcano.8": "#ad2102",
	"volcano.9": "#871400",
	"volcano.10": "#610b00",
	"geekblue.1": "#e5f9ff",
	"geekblue.2": "#bee8f5",
	"geekblue.3": "#98d6ea",
	"geekblue.4": "#4cb2d4",
	"geekblue.5": "#26a0c9",
	"geekblue.6": "#008ebe",
	"geekblue.7": "#007ca1",
	"geekblue.8": "#006786",
	"geekblue.9": "#00526b",
	"geekblue.10": "#003d50",
	"lime.1": "#f8fbe9",
	"lime.2": "#f0f8d6",
	"lime.3": "#eaf5c3",
	"lime.4": "#e4f2b0",
	"lime.5": "#deef9d",
	"lime.6": "#b2c270",
	"lime.7": "#8a9755",
	"lime.8": "#626c3a",
	"lime.9": "#3a411f",
	"lime.10": "#121604",
	"gold.1": "#fdf8ee",
	"gold.2": "#fae9cd",
	"gold.3": "#f6deb0",
	"gold.4": "#f2d393",
	"gold.5": "#eabd59",
	"gold.6": "#FAAD14",
	"gold.7": "#8c7135",
	"gold.8": "#755f2d",
	"gold.9": "#5e4c24",
	"gold.10": "#413314",
	"philippineGray": "#8c8c8c",
	"gray.98": "#fafafa",
	"colorText": "#000000",
	"colorTextLightSolid": "#ffffff",
	"colorBg": "#ffffff",
	"fontFamily": "Inter",
	"fontSize": 14,
	"lineWidth": 1,
	"borderRadius": 6,
	"sizeUnit": 4,
	"sizePopupArrow": 16,
	"controlHeight": 32,
	"opacityImage": 1,
	"sizeStep": 4,
	"sizeXXL": 48,
	"sizeXL": 32,
	"sizeLG": 24,
	"sizeMD": 20,
	"sizeMS": 16,
	"size": 16,
	"sizeSM": 12,
	"sizeXS": 8,
	"sizeXXS": 4,
	"controlHeightSM": 24,
	"controlHeightXS": 16,
	"controlHeightLG": 40,
	"tableInlineSizesXS": 40,
	"tableInlineSizesS": 114,
	"tableInlineSizesSM": 120,
	"tableInlineSizesM": 150,
	"tableInlineSizesLG": 200,
	"borderRadiusXXS": 1,
	"borderRadiusXS": 2,
	"borderRadiusSM": 4,
	"borderRadiusLG": 8,
	"borderRadiusOuter": 4,
	"colorTextSecondary": "rgba(0, 0, 0, 0.65)",
	"colorTextTertiary": "rgba(0, 0, 0, 0.45)",
	"colorTextQuaternary": "rgba(0, 0, 0, 0.25)",
	"colorFill": "rgba(0, 0, 0, 0.15)",
	"colorFillSecondary": "rgba(0, 0, 0, 0.06)",
	"colorFillTertiary": "rgba(0, 0, 0, 0.04)",
	"colorBgContainer": "#ffffff",
	"colorFillQuaternary": "rgba(0, 0, 0, 0.02)",
	"colorBgLayout": "#F8F8F8",
	"colorBgElevated": "#ffffff",
	"colorBgSpotlight": "rgba(0, 0, 0, 0.88)",
	"colorBorder": "rgba(0, 0, 0, 0.15)",
	"colorBorderSecondary": "rgba(0, 0, 0, 0.06)",
	"colorSplit": "rgba(0, 0, 0, 0.06)",
	"colorPrimaryBg": "#efedf7",
	"colorPrimaryBgHover": "#C8C1FA",
	"colorPrimaryBorder": "#ACA1F7",
	"colorPrimaryBorderHover": "#9082F4",
	"colorPrimaryHover": "#7563F2",
	"colorPrimary": "#5944EF",
	"colorPrimaryActive": "#4A39C7",
	"colorPrimaryTextHover": "#3B2D9F",
	"colorPrimaryText": "#2D2278",
	"colorPrimaryTextActive": "#1E1750",
	"colorSuccessBg": "#f5fefb",
	"colorSuccessBgHover": "#DEFAE9",
	"colorSuccessBorder": "#B9EDCF",
	"colorSuccessBorderHover": "#6ec391",
	"colorSuccessHover": "#49b476",
	"colorSuccess": "#25a55a",
	"colorSuccessActive": "#1f8a4b",
	"colorSuccessTextHover": "#196e3c",
	"colorSuccessText": "#13532d",
	"colorSuccessTextActive": "#0c371e",
	"colorWarningBg": "#fdf8ee",
	"colorWarningBgHover": "#fae9cd",
	"colorWarningBorder": "#f6deb0",
	"colorWarningBorderHover": "#eabd59",
	"colorWarningHover": "#f2d393",
	"colorWarning": "#bb9747",
	"colorWarningActive": "#8c7135",
	"colorWarningTextHover": "#755f2d",
	"colorWarningText": "#5e4c24",
	"colorWarningTextActive": "#d48806",
	"colorErrorBg": "#FFF2F0",
	"colorErrorBgHover": "#f1cbca",
	"colorErrorBorder": "#e6acab",
	"colorErrorBorderHover": "#db8d8c",
	"colorErrorHover": "#db8d8c",
	"colorError": "#EA473B",
	"colorErrorActive": "#982925",
	"colorErrorTextHover": "#77201d",
	"colorErrorText": "#561715",
	"colorErrorTextActive": "#350e0d",
	"colorInfoBg": "#e5f3ff",
	"colorInfoBgHover": "#98c6f2",
	"colorInfoBorder": "#72b0ea",
	"colorInfoBorderHover": "#4c9ae2",
	"colorInfoHover": "#2684da",
	"colorInfo": "#006ed2",
	"colorInfoActive": "#005db5",
	"colorInfoTextHover": "#004d96",
	"colorInfoText": "#003d77",
	"colorInfoTextActive": "#001d39",
	"stepsDotSize": 8,
	"stepsCurrentDotSize": 10,
	"rateStarSize": 20,
	"colorBorderBg": "#ffffff",
	"colorLink": "#1677FF",
	"colorLinkHover": "#1677FA",
	"colorLinkActive": "#4A39C7",
	"colorHighlight": "#db8d8c",
	"controlOutline": "#efedf7",
	"colorWarningOutline": "#fdf8ee",
	"colorErrorOutline": "#faebeb",
	"fontSizeSM": 12,
	"fontSizeLG": 16,
	"fontSizeXL": 20,
	"fontSizeIcon": 12,
	"fontSizeHeading1": 38,
	"fontSizeHeading2": 30,
	"fontSizeHeading3": 24,
	"fontSizeHeading4": 20,
	"fontSizeHeading5": 16,
	"fontWeightNormal": 400,
	"fontWeightBold": 500,
	"fontWeightBolder": 600,
	"fontWeightStrong": 700,
	"controlLineWidth": 1,
	"controlOutlineWidth": 2,
	"controlItemBgActive": "#efedf7",
	"controlItemBgActiveHover": "#C8C1FA",
	"controlItemBgHover": "rgba(0, 0, 0, 0.04)",
	"controlInteractiveSize": 16,
	"opacityLoading": 0.65,
	"padding": 16,
	"paddingMD": 20,
	"paddingSM": 12,
	"paddingS": 10,
	"paddingXS": 8,
	"paddingXXS": 4,
	"paddingLG": 24,
	"paddingXL": 32,
	"paddingXXL": 48,
	"margin": 16,
	"marginSM": 12,
	"marginXS": 8,
	"marginXXS": 4,
	"marginLG": 24,
	"marginXL": 48,
	"controlPaddingHorizontal": 12,
	"controlPaddingHorizontalSM": 8,
	"paddingContentHorizontalLG": 24,
	"paddingContentVerticalLG": 16,
	"paddingContentHorizontal": 16,
	"paddingContentVertical": 12,
	"paddingContentHorizontalSM": 16,
	"paddingContentVerticalSM": 8,
	"boxShadow": "0 1px 2px rgba(0, 0, 0, 0.03), 0 1px 6px -1px rgba(0, 0, 0, 0.02), 0 2px 4px rgba(0, 0, 0, 0.02)",
	"boxShadowSecondary": "0 6px 16px rgba(0, 0, 0, 0.08), 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 9px 28px 8px rgba(0, 0, 0, 0.05)",
	"boxShadowCard": "0 1px 2px -2px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.12), 0 5px 12px 4px rgba(0, 0, 0, 0.09)",
	"colorItemTextDisabled": "rgba(255, 255, 255, 0.25)",
	"focusPrimary": "0 0 0 2px rgb(0, 0, 0)",
	"focusError": "0 0 0 2px rgb(0, 0, 0)",
	"focusWarning": "0 0 0 2px rgb(0, 0, 0)",
	"segmentedBgColorSelected": "#ffffff",
	"colorMenuDarkBg": "#1E1750",
	"colorMenuSubItemBg": "#000c17",
	"paddingTooltipContentVertical": 6
}
